export const ratedCompetencesChart = {
	absolutePosition: true,
	condition: null,
	filter: null,
	height: {
		unit: "POINT",
		value: 222.5
	},
	loop: null,
	// The member must exist on a freshly inserted block, because the report
	// template editor patches it with a replace.
	scoreAggregation: "LATEST",
	type: "rated-competences-chart",
	width: {
		unit: "POINT",
		value: 495.0
	},
	x: {
		unit: "POINT",
		value: 50.0
	},
	y: {
		unit: "POINT",
		value: 375.0
	}
};